import React, { Component } from "react";
 
class Home extends Component {
  render() {
    return (
      <div>
        <h2>Ovocie</h2>
        <p>Príroda a blízkosť rieky sa odráža v chuti
           nášho ovocia. Chutné ovocie z brehu Malého
           Dunaja, čerstvé od pestovateľa.</p>
        <h2>Záhrada</h2>
        <p>Moji prarodičia pestovali záhradu pozdĺž
           Malého Dunaja, kde ich farma bola roztiahnutá.
           Podobne ako moji prarodičia, moji starí rodičia
           rozšírili záhradu, aby udržali ovocné stromy až
           do roku 2017, keď môj starý otec dovŕšil vek 80
           rokov. Potom sme sa začali mi s mojou rodinou
           starať o sadovú záhradu.</p>
        <h2>Turistika a príroda</h2>
        <p>Môžete získať náhľad do Žitno Ostrovskej prírody 
          v rámci malého rodinnom výletu. Krásnu prírodu ocenia
          najmä návštevníci s umeleckým duchom. K našej záhrade
          môžeme prísť ako na vode, tak aj po zemi a v našej
          záhrade Vás rád poprevádzam a z nášho ovocia si môžete 
          spraviť ochutnávku. Tomašikovský mlyn, mŕtve ramená
          Malého Dunaja, plavba člnom, rybárčenie, športové
          zariadenie a jedlo (v reštaurácii pri mlyne) 500 m
          od našej záhrady.</p>
      </div>
    );
  }
}
 
export default Home;



// WEBPACK FOOTER //
// ./src/Home.js